import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500">
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          {idx > 0 && <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-300"><i className="ri-arrow-right-s-line"></i></span>}
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}